module.exports = __webpack_public_path__ + "static/media/mc_screen_typing.a4e02ae6.svg";